export default __webpack_public_path__ + "111bd0cf707714f8461d7206a36cc406.gif";